var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Group from './Group';
import Element from './Element';
var CustomElement = /** @class */ (function (_super) {
    __extends(CustomElement, _super);
    function CustomElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.$$CustomType = true;
        return _this;
    }
    Object.defineProperty(CustomElement.prototype, "isGroup", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    CustomElement.prototype.skipUpdate = function () {
        this._updated = true;
    };
    CustomElement.prototype.forceUpdate = function () {
        this.update();
    };
    CustomElement.prototype.getObservedAttr = function () {
        return [];
    };
    CustomElement.prototype.created = function () {
        if (!this._updated) {
            this.update();
        }
    };
    CustomElement.prototype.shouldUpdate = function () {
        return !this._updated;
    };
    CustomElement.prototype.update = function () {
        if (this.shouldUpdate()) {
            var renderObjs = this.render();
            this.clear();
            this.addAll(Array.isArray(renderObjs) ? renderObjs : [renderObjs].filter(function (item) { return item; }));
        }
        this._updated = true;
    };
    CustomElement.prototype.onAttrChange = function (key, value, oldValue) {
        _super.prototype.onAttrChange.call(this, key, value, oldValue);
        if (this.getObservedAttr().indexOf(key) !== -1) {
            this._updated = false;
        }
    };
    CustomElement.prototype.render = function () {
        return null;
    };
    return CustomElement;
}(Group));
export default CustomElement;
